// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"a55e5cfd","113":"f2a7189a","200":"94dd6076","210":"9218bdf7","523":"2f0ec380","706":"e83be57c","708":"afd181aa","770":"c5e8e1e5","845":"fda2be14","852":"5061bf9d","855":"1cf98fb0"}[chunkId] + ".chunk.js";
};